import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCompleteBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 21.9998C6.47715 21.9998 2 17.5226 2 11.9998C2 6.47691 6.47715 1.99976 12 1.99976C17.5228 1.99976 22 6.47691 22 11.9998C22 17.5226 17.5228 21.9998 12 21.9998ZM11.0026 15.9998L18.0737 8.92869L16.6595 7.51448L11.0026 13.1714L8.17421 10.3429L6.75999 11.7572L11.0026 15.9998Z",
		fill: "#0587FB"
	})
});
export default SvgIconCompleteBlue;
